export default __webpack_public_path__ + "static/RC_S2-05a62fa39a3e79810978012e91d8f26e.png";